export default function SpinnerBorder() {
  return (
    <div className="flex gap-2 items-center">
      <div class="animate-spin h-5 w-5 border-white border-[0.25rem] border-t-transparent rounded-full" viewBox="0 0 24 24" />
      Processing...
    </div>
  );
}
